import React, { FC } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/Logo.svg";
import { useStyles } from "./Styles";

interface Props {
  location: any;
}

const Logo: FC<Props> = ({ location }) => {
  const classes = useStyles();
  const locationClass = location !== "Landing" ? "inner" : "";
  return (
    <div className={`${classes.logo} ${locationClass}`}>
      <Link to="/my-listing">
        <div className={classes.LogoImage}>
          <img height={32} width="auto" src={logo} alt="Exits Logo" />
        </div>
      </Link>
    </div>
  );
};

export default Logo;
